import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Route, Routes } from 'react-router';

import { Layout } from './components/Layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Feedback } from './pages/Feedback';
import { NewHires } from './pages/NewHires';
import { NotFound } from './pages/NotFound';
import { QAQueue } from './pages/QAQueue';
import { Reviewers } from './pages/Reviewers';
import { ReviewForm } from './pages/ReviewForm';
import { Reviews } from './pages/Reviews';
import { Spotchecks } from './pages/Spotchecks';
import { TicketLookup } from './pages/TicketLookup';

const basename = process.env.BASEURL ? `/${process.env.BASEURL}` : '/';

export function Root() {
  return (
    <HelmetProvider>
      <BrowserRouter basename={basename}>
        <Helmet defaultTitle="Ticket Review" titleTemplate="%s | Ticket Review" />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tickets" element={<TicketLookup />} />
            <Route path="/queue" element={<QAQueue />} />
            <Route path="/review" element={<ReviewForm />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/new-hires" element={<NewHires />} />
            <Route path="/reviewers" element={<Reviewers />} />
            <Route path="/spotchecks" element={<Spotchecks />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default Root;
